var App = App || {};

App.Footer = (function ($) {
    'use strict';

    function Init() {
        App.Base.RegisterCopyButton({
            buttonSelector: '#site-footer-routing-copy',
            statusSelector: '#site-footer-routing-status',
            dataKey: 'routing-number',
            successMessage: 'Routing number copied to clipboard.',
            errorMessage: 'Unable to copy routing number. Please try again or copy manually.'
        });

        App.Base.RegisterCopyButton({
            buttonSelector: '#site-footer-nmls-copy',
            statusSelector: '#site-footer-nmls-status',
            dataKey: 'nmls-number',
            successMessage: 'NMLS copied to clipboard.',
            errorMessage: 'Unable to copy NMLS. Please try again or copy manually.'
        });

        App.Base.RegisterCopyButton({
            buttonSelector: '#header-offcanvas-routing-copy',
            statusSelector: '#header-offcanvas-routing-status',
            dataKey: 'routing-number',
            successMessage: 'Routing number copied to clipboard.',
            errorMessage: 'Unable to copy routing number. Please try again or copy manually.'
        });
    }

    return {
        Init: Init
    };

})(jQuery);
